import React, { ReactNode, useEffect } from 'react';
import Logo from '@components/Logo';

import * as S from './styles';

interface PortalSpinnerProps {
  children?: ReactNode;
}

const PortalSpinner = ({ children }: PortalSpinnerProps) => {
  useEffect(() => {
    const documentOverflow = (overflow: string) => {
      document.body.style.overflow = overflow;
    };
    documentOverflow('hidden');

    return () => {
      documentOverflow('auto');
    };
  }, []);

  return (
    <S.PortalSpinnerContainer>
      <div className="logo-content">
        <Logo className="breathing-img" />
        {children}
      </div>
    </S.PortalSpinnerContainer>
  );
};

export default PortalSpinner;
